import { jsx } from "react/jsx-runtime";
import { formatDate } from "@batiflow/i18n";
import { Input } from "@fluentui/react-components";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { FormField, fieldErrorText } from "../form-field/form-field.js";
import { useLocale } from "../internal/use-locale.js";
const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
function DateInput({
  value,
  onChange,
  min,
  max,
  label,
  hint,
  error,
  required,
  disabled,
  name,
  "aria-label": ariaLabel,
  onBlur
}) {
  const { t } = useTranslation("ui");
  const locale = useLocale();
  const [touched, setTouched] = useState(false);
  const show = (iso) => formatDate(`${iso}T12:00:00Z`, locale);
  const range = !touched || !ISO_DATE.test(value) ? null : min && ISO_DATE.test(min) && value < min ? t("components.dateInput.before", { min: show(min) }) : max && ISO_DATE.test(max) && value > max ? t("components.dateInput.after", { max: show(max) }) : null;
  return /* @__PURE__ */ jsx(
    FormField,
    {
      ...label ? { label } : {},
      ...hint ? { hint } : {},
      ...required ? { required } : {},
      error: range ?? fieldErrorText(error),
      children: /* @__PURE__ */ jsx(
        Input,
        {
          ...name ? { name } : {},
          ...ariaLabel ? { "aria-label": ariaLabel } : {},
          ...disabled ? { disabled } : {},
          ...min ? { min } : {},
          ...max ? { max } : {},
          type: "date",
          value,
          dir: "ltr",
          root: { dir: "ltr" },
          onChange: (event) => {
            onChange(event.target.value);
          },
          onBlur: () => {
            setTouched(true);
            onBlur?.();
          }
        }
      )
    }
  );
}
export {
  DateInput
};
//# sourceMappingURL=date-input.js.map